module.exports = __webpack_public_path__ + "img/useTicket.dc5ffbe0.gif";